<template>
  <div class="page-training-detail"
       v-if="training.id > 0"
  >
    <component class="training-detail"
               :is="currentView"
               :current-view="currentView"
               @joined="handleJoined"
               @show-detail="handleShowDetail"
               is-show-share
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import JoinedDetail from '@/pages/Training/components/TrainingDetailJoined';
  import TrainingDetailSellPage from '@/pages/Training/components/TrainingDetailSellPage';
  import { isTrainingMember } from '@/services/training';

  export default {
    name: 'PageTrainingDetail',
    metaInfo() {
      return {
        title: this.training.title,
      };
    },
    components: {
      JoinedDetail,
      TrainingDetailSellPage,
    },
    data() {
      return {
        training: {
          id: 0,
          title: '',
        },
        currentView: 'TrainingDetailSellPage',
      };
    },
    computed: {
      ...mapGetters([
        'player',
      ]),
    },
    methods: {
      fetchData(id) {
        this.isTrainingMember(id);
      },
      async isTrainingMember(trainingId) {
        const data = await isTrainingMember(trainingId);
        this.training = data.training;
        const { training } = data;
        const { joinStatus, type } = training;
        if (type !== 'offline' && joinStatus === 'member') {
          this.currentView = 'JoinedDetail';
        } else {
          this.currentView = 'TrainingDetailSellPage';
        }
      },
      handleJoined() {
        this.currentView = 'JoinedDetail';
      },
      handleShowDetail() {
        this.currentView = 'TrainingDetailSellPage';
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchData(id);
    },
    beforeRouteUpdate(to, from, next) {
      this.currentView = 'TrainingDetailSellPage';
      const { id } = to.params;
      this.fetchData(id);
      next();
    },
    beforeRouteLeave(to, from, next) {
      this.player.pause();
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-training-detail {
    height: 100%;
    box-sizing: border-box;
    background-color: @color-white;
  }

</style>
